export const USERS_SET_LIST_DATA = 'USERS_SET_LIST_DATA';
export const USERS_SET_LIST_META = 'USERS_SET_LIST_META';
export const USERS_TITLE="Tài khoản";